import {
  CampaignType,
  CampaignCondition,
  CouponDiscount,
  CouponDiscountPercentage,
  CouponItem,
} from '~/types/coupon';
import formatPriceNumber from '~/utils/formatPriceNumber';
import * as fp from 'lodash/fp';

export default function transformCouponDiscountString(
  couponType: CampaignType,
  condition: CampaignCondition,
): string {
  const conditionDiscount: CouponDiscount | undefined = fp.prop(CampaignType.DISCOUNT)(condition);
  const conditionDiscountPercentage: CouponDiscountPercentage | undefined = fp.prop(
    CampaignType.DISCOUNT_PERCENTAGE,
  )(condition);
  const conditionItem: CouponItem | undefined = fp.prop(CampaignType.ITEM)(condition);

  if (fp.eq(CampaignType.DISCOUNT, couponType) && conditionDiscount) {
    return `滿${formatPriceNumber(conditionDiscount.costLimit)} 折抵${formatPriceNumber(
      conditionDiscount.discount,
    )}`;
  }

  if (fp.eq(CampaignType.DISCOUNT_PERCENTAGE, couponType) && conditionDiscountPercentage) {
    return `滿${formatPriceNumber(conditionDiscountPercentage.costLimit)} 折${
      conditionDiscountPercentage.percentage * 100
    }%，最多折抵${formatPriceNumber(conditionDiscountPercentage.discountLimit)}`;
  }

  if (fp.eq(CampaignType.ITEM, couponType) && conditionItem) {
    return `滿${formatPriceNumber(conditionItem.costLimit)} 獲得${conditionItem.name}`;
  }

  if (fp.eq(CampaignType.PLATFORM, couponType)) {
    return `平台折扣`;
  }

  return '優惠券資訊有誤';
}
